module.exports = __webpack_public_path__ + "static/media/Journal-new-cover.ad31fb3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Journal-new-cover.jpg
// module id = 1357
// module chunks = 1